var map = {
	"./useApp.jsx": 8144,
	"./useBreakpoints.jsx": 9502,
	"./useCopyToClipboard.jsx": 1210,
	"./useDBPFragments.jsx": 9126,
	"./useInterval.jsx": 9921,
	"./useKeyPress.jsx": 9640,
	"./useSanityCustomPages.jsx": 9221,
	"./useSanityPages.jsx": 2802,
	"./useSanitySettings.jsx": 8887,
	"./useSanitySlices.jsx": 2084,
	"./useScroll.jsx": 2472,
	"./useSidebarLinks.jsx": 4886,
	"./useSiteMetadata.jsx": 8334,
	"./useTimeout.jsx": 7342,
	"./useWindowDimensions.jsx": 2819,
	"./useWindowSize.jsx": 6347
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 453;